module.exports = __webpack_public_path__ + "28b84804a9f16923f73861c7fce63a13.pdf";